import { useMutation, useQuery } from '@apollo/client'
import createFileType from 'graphQL/dataManager/MutationCreateFileType'
import listFileType from 'graphQL/dataManager/listFileType'
import MutationUpdateFileType from 'graphQL/dataManager/MutationUpdateFileType'
import MutationDeleteFileType from 'graphQL/dataManager/MutationDeleteFileType'

export const useListFileType = (options) => {
  return useQuery(listFileType, options)
}

export const useCreateFileType = (options) => {
  return useMutation(createFileType, options)
}

export const useUpdateFileType = (options) => {
  return useMutation(MutationUpdateFileType, options)
}

export const useDeleteFileType = (options) => {
  return useMutation(MutationDeleteFileType, options)
}
